module.exports = __webpack_public_path__ + "img/sve.9c624146.svg";